import React from 'react';

import { Button, Modal, ModalHeader, ModalFooter } from 'reactstrap';

import './ConfirmModal.scss';

const ConfirmModal = (props) => {
  const { onCancelClick, onConfirmClick, confirmTitle, isOpen, onToggleModal } = props;

  let { cancelTitle, prompt } = props;

  if (!cancelTitle) cancelTitle = 'Cancel';
  if (!prompt) prompt = 'Are you sure?';

  return (
    <div>
      <Modal isOpen={isOpen} toggle={onToggleModal} className={props.className} backdrop={'static'} keyboard={false}>
        <ModalHeader toggle={onToggleModal}>{prompt}</ModalHeader>
        <ModalFooter>
          <Button color="secondary" onClick={onCancelClick}>
            {cancelTitle}
          </Button>
          <Button color="danger" onClick={onConfirmClick}>
            {confirmTitle}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ConfirmModal;
